import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import API from "../../Common/Endpoint/serviceConstrants";
import axiosInstance from "../../Common/Axios/axiosInstance";




export const cardMasterSlice = createSlice({
    name: "card-master-data",
    initialState: {
        isLoading: false,
        isError: false,
        cardMasterData: [],
        message: "",
        isgetLoading: true,
    },
    reducers: {
        onGetCardMasterData: (state) => {
            return {
                ...state,
                isgetLoading: true,
                cardMasterData: [],
                message: "",
            };
        },

        onGetCardMasterSuccess: (state, { payload }) => {
            const { data = [], message = "", status_code = 200 } = payload;
            return {
                ...state,
                isgetLoading: false,
                cardMasterData: data,
                getmessage: message,
                get_status_code: status_code,
            };
        },

        onGetCardMasterError: (state, { payload }) => {
            const { data = [], message = "", status_code = 400 } = payload;
            return {
                ...state,
                cardMasterData: data,
                getmessage: message,
                get_status_code: status_code,
                isgetLoading: false,
            };
        },
        onGetCardMasterDataReset: (state) => {

            return {
                ...state,
                get_status_code: null,
                isgetLoading: false,
            };
        },
    },


});

export const {
    onGetCardMasterData,
    onGetCardMasterSuccess,
    onGetCardMasterError,
    onGetCardMasterDataReset
} = cardMasterSlice.actions;

export default cardMasterSlice.reducer;
